<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col cols="12">
        <v-card>
          <v-data-table
            :items="movimientos"
            :headers="movimientosTblHeaders"
            :search="movimientosSearch"
            :footer-props="footerProps"
            :loading="showTableLoadingMsg"
            loading-text="Cargando... Espera por favor..."
            no-data-text="Ningún movimiento para mostrar"
            no-results-text="Ningún movimiento encontrado para la búsqueda"
          >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title>Movimientos Caja</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="movimientosSearch"
                  append-icon="mdi-magnify"
                  hide-details
                  label="Buscar movimiento"
                  class="mx-4"
                ></v-text-field>
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="dateRangeText"
                  label="Ver para el rango fechas"
                  prepend-icon="mdi-calendar"
                  readonly
                  @click="openDatePickerModal(context)"
                ></v-text-field>
                <NavDatePickerModal
                  :context="context"
                  @dateRangeSelected="fetchMovimientosInDateRange"
                />
              </v-toolbar>
            </template>
            <template v-slot:item.codigo="{ item }">
              {{ item.codigo ? item.codigo : defaultMsg }}
            </template>
            <template v-slot:item.monto="{ item }">
              <span class="font-weight-bold">
                {{ item.monto ? `$${item.monto}` : defaultMsg }}
              </span>
            </template>
            <template v-slot:item.denominacion="{ item }">
              {{ item.denominacion ? `$${item.denominacion}` : defaultMsg }}
            </template>
            <template v-slot:item.saldo="{ item }">
              {{ item.saldo ? `$${item.saldo}` : defaultMsg }}
            </template>
            <template v-slot:item.id_usuario="{ item }">
              <span class="font-weight-bold">
                {{ item.nombreUsuario ? item.nombreUsuario : defaultMsg }}
              </span>
            </template>
            <template v-slot:item.co_responsable="{ item }">
              {{
                item.co_responsable
                  ? nombreCliente(item.co_responsable)
                  : defaultMsg
              }}
            </template>
            <template v-slot:item.fecha="{ item }">
              {{ formatDate(item.fecha) }}
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// const {getUltimoCorte, getCortesCount, getCobros, getMovimientosAll, getFondoCaja, getTotal} = api.services.cajaService;
import { humanDateFormat } from "../../services/utils";
import NavDatePickerModal from "../NavDatePickerModal.vue";
import dataTableMixin from "../../mixins/mixin-data-tables";
// const { getMovimientosByDateRange } = api.services.cajaService;
// const { getClienteByID } = api.services.clientesService;
export default {
  name: "ReporteMovimeintosCaja",
  components: {
    NavDatePickerModal,
  },
  mixins: [dataTableMixin],
  data() {
    return {
      context: "REPORTE_MOVIMIENTOS_CAJA",
      defaultMsg: "N/A",
      movimientosSearch: "",
      footerProps: {
        "items-per-page-text": "Filas a mostrar",
        "items-per-page-options": [5, 10, 30, 50, 100, -1],
      },
      movimientos: [],
      movimientosTblHeaders: [
        {
          text: "#",
          align: "right",
          sortable: true,
          value: "id",
          width: "1%",
        },
        {
          text: "Codigo",
          align: "left",
          sortable: true,
          value: "codigo",
        },
        {
          text: "Tipo",
          align: "left",
          sortable: true,
          value: "tipo",
        },
        {
          text: "Monto",
          align: "left",
          sortable: true,
          value: "monto",
        },
        {
          text: "Denominación",
          align: "left",
          sortable: true,
          value: "denominacion",
        },
        {
          text: "Saldo",
          align: "left",
          sortable: true,
          value: "saldo",
        },
        {
          text: "Concepto",
          align: "left",
          sortable: true,
          value: "concepto",
        },
        {
          text: "Usuario",
          align: "left",
          sortable: true,
          value: "id_usuario",
          width: "1%",
        },
        {
          text: "Cliente",
          align: "left",
          sortable: true,
          value: "co_responsable",
          width: "10%",
        },
        {
          text: "Fecha",
          align: "right",
          sortable: true,
          value: "fecha",
          width: "20%",
        },
      ],
    };
  },
  methods: {
    getMovimientosByDateRange(){},
    getClienteByID(){},
    fetchMovimientos() {
      this.showTableLoadingMsg = true;
      const [startDate, endDate] = this.selectedDates;
      const startDateTimeStr = `${startDate} ${this.startTime}`;
      const endDateTimeStr = `${endDate} ${this.endTime}`;
      this.getMovimientosByDateRange(startDateTimeStr, endDateTimeStr).then(
        (movimientos) => {
          this.showTableLoadingMsg = false;
          this.movimientos = movimientos ? movimientos.reverse() : [];
        }
      );
    },
    fetchMovimientosInDateRange(dates) {
      const startDate = dates[0];
      const endDate = dates && dates[1] ? dates[1] : startDate;
      const startDateTimeStr = `${startDate} ${this.startTime}`;
      const endDateTimeStr = `${endDate} ${this.endTime}`;
      this.showTableLoadingMsg = true;
      this.getMovimientosByDateRange(startDateTimeStr, endDateTimeStr).then(
        (movimientos) => {
          this.showTableLoadingMsg = false;
          this.movimientos = movimientos ? movimientos.reverse() : [];
        }
      );
    },
    nombreCliente(id) {
      const cliente = this.getClienteByID(id);
      const nombre = `${cliente.nombre} ${cliente.apellido}`;
      return nombre;
    },
    formatDate(dateStr) {
      return humanDateFormat(dateStr, "es");
    },
  },
  beforeMount() {
    this.fetchMovimientos();
  },
};
</script>